/* =====================================================
   CARBON B2B WHOLESALE THEME — Main JS v1.1
   Fixed: event delegation, BOG init, cart badge
   ===================================================== */
'use strict';

// ── TOAST ──
window.CarbonToast = {
  show(msg, duration) {
    duration = duration || 2500;
    var t = document.getElementById('carbon-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'carbon-toast';
      t.className = 'carbon-toast';
      t.innerHTML = '<div class="carbon-toast__check">✓</div><span id="carbon-toast-msg"></span>';
      document.body.appendChild(t);
    }
    document.getElementById('carbon-toast-msg').textContent = msg;
    t.classList.add('show');
    clearTimeout(t._t);
    t._t = setTimeout(function() { t.classList.remove('show'); }, duration);
  }
};

// ── CART BADGE ──
function updateCartBadge() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      document.querySelectorAll('.carbon-cart-badge__count').forEach(function(b) {
        b.textContent = cart.item_count;
        b.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
      if (cart.item_count > 0) {
        trackAbandonedCartGlobal(cart);
      } else {
        clearAbandonedCartGlobalIfTracked();
      }
    })
    .catch(function() {});
}

// ── ABANDONED CART WHATSAPP NUDGES ──
// For a known phone (logged-in Shopify customer, or an existing OTP session from
// Generate PI / wholesaler login) we don't need to wait for the OTP flow — start
// tracking the moment there's a non-empty cart. Guests with no known phone yet are
// only tracked later, once they verify OTP on the Generate PI page (see that page's
// own trackAbandonedCart()), since we genuinely don't have a number for them before that.
var ZAPIER_ABANDON_TRACK_WEBHOOK = 'https://hooks.zapier.com/hooks/catch/28057504/44mgsvg/';
var ZAPIER_ABANDON_CLEAR_WEBHOOK = 'https://hooks.zapier.com/hooks/catch/28057504/44mg0ht/';
var ABANDON_TRACKED_KEY_PREFIX   = 'carbon_abandon_tracked_v1_';
var ABANDON_SESSION_KEY          = 'carbon_pi_session_v1';
var ABANDON_SESSION_TTL          = 8 * 60 * 60 * 1000; // 8 hours

function getKnownPhoneForAbandonTracking() {
  if (window.CarbonCustomerPhone) {
    return window.CarbonCustomerPhone.replace(/^\+91/, '').replace(/\D/g, '');
  }
  try {
    var raw = localStorage.getItem(ABANDON_SESSION_KEY);
    if (!raw) return '';
    var s = JSON.parse(raw);
    if (Date.now() - s.ts > ABANDON_SESSION_TTL) return '';
    return s.phone || '';
  } catch (e) { return ''; }
}

function getKnownNameForAbandonTracking(phone) {
  if (window.CarbonCustomerName) return window.CarbonCustomerName;
  // Not logged in to a real Shopify session — check for a name saved locally
  // from a previous Generate PI "Business Details" submission on this device.
  try {
    var raw = localStorage.getItem('carbon_pi_buyer_v1_' + phone);
    if (raw) {
      var saved = JSON.parse(raw);
      if (saved && saved.name) return saved.name;
    }
  } catch (e) {}
  return 'there'; // template {{1}} shouldn't render as a blank gap
}

function getPiecesPerVariantForAbandonTracking(item) {
  var raw = item && item.properties ? item.properties._pieces_per_variant : null;
  var pieces = parseInt(raw || '1', 10);
  return pieces && pieces > 0 ? pieces : 1;
}

function trackAbandonedCartGlobal(cart) {
  var phone = getKnownPhoneForAbandonTracking();
  if (!phone || !cart || !cart.items || cart.items.length === 0) return;

  var hash = cart.items.map(function(item) {
    return item.variant_id + ':' + item.quantity;
  }).sort().join('|');

  var trackedKey = ABANDON_TRACKED_KEY_PREFIX + phone;
  try {
    var prev = JSON.parse(localStorage.getItem(trackedKey) || 'null');
    if (prev && prev.hash === hash) return; // already tracked this exact cart state
  } catch (e) {}

  var subtotal = cart.items.reduce(function(sum, item) {
    var ppc = getPiecesPerVariantForAbandonTracking(item);
    var raw = (item.price / 100) * item.quantity * ppc;
    return sum + Math.ceil(raw / 10) * 10;
  }, 0);

  var totalSets = cart.items.reduce(function(s, i) { return s + i.quantity; }, 0);
  var itemsSummary = totalSets + ' set' + (totalSets === 1 ? '' : 's') + ' · '
    + cart.items.length + ' product' + (cart.items.length === 1 ? '' : 's');

  var itemsStr = cart.items.map(function(item) {
    var ppc = getPiecesPerVariantForAbandonTracking(item);
    return [
      item.variant_id,
      item.quantity,
      item.price / 100,
      ppc,
      encodeURIComponent(item.product_title || ''),
      encodeURIComponent(item.variant_title || ''),
      encodeURIComponent(item.sku || '')
    ].join(',');
  }).join('|');

  fetch(ZAPIER_ABANDON_TRACK_WEBHOOK, {
    method: 'POST',
    mode: 'no-cors',
    body: JSON.stringify({
      event:         'abandoned_cart_track',
      phone:         '+91' + phone,
      customer_name: getKnownNameForAbandonTracking(phone),
      cart_token:    cart.token || '',
      subtotal:      subtotal,
      items_str:     itemsStr,
      items_summary: itemsSummary,
      tracked_at:    new Date().toISOString()
    })
  }).catch(function(err) {
    console.error('[Carbon] Abandoned cart track webhook failed:', err);
  });

  try { localStorage.setItem(trackedKey, JSON.stringify({ hash: hash, ts: Date.now() })); } catch (e) {}
}

// Cart emptied from the cart page directly (not via Generate PI) — cancel any
// pending nudges for this phone if one was actually being tracked.
function clearAbandonedCartGlobalIfTracked() {
  var phone = getKnownPhoneForAbandonTracking();
  if (!phone) return;

  var trackedKey = ABANDON_TRACKED_KEY_PREFIX + phone;
  if (!localStorage.getItem(trackedKey)) return; // nothing was ever tracked, don't bother Zapier

  fetch(ZAPIER_ABANDON_CLEAR_WEBHOOK, {
    method: 'POST',
    mode: 'no-cors',
    body: JSON.stringify({
      event:      'abandoned_cart_clear',
      phone:      '+91' + phone,
      reason:     'cart_emptied',
      cleared_at: new Date().toISOString()
    })
  }).catch(function(err) {
    console.error('[Carbon] Abandoned cart clear webhook failed:', err);
  });

  try { localStorage.removeItem(trackedKey); } catch (e) {}
}

// ── BULK ORDER GRID CLASS ──
function BulkOrderGrid(el) {
  this.el = el;
  this.productId = el.dataset.productId;
  this.productName = el.dataset.productName;
  this.price = parseFloat(el.dataset.price || 0);
  // selections: key = 'color::sizeset', value = qty (integer)
  this.selections = {};
  this._initSteppers();
}

BulkOrderGrid.prototype._initSteppers = function() {
  var self = this;
  this.el.querySelectorAll('.carbon-bog__stepper').forEach(function(stepper) {
    var decBtn  = stepper.querySelector('.carbon-bog__dec');
    var incBtn  = stepper.querySelector('.carbon-bog__inc');
    var color   = stepper.dataset.color || '';
    var sizeset = stepper.dataset.sizeset || '';
    var available = stepper.dataset.available !== 'false' && !!stepper.dataset.variantId;
    var key     = color + '::' + sizeset;

    function getQty() { return self.selections[key] || 0; }

    self.setQuantityForStepper(stepper, 0);

    incBtn.addEventListener('click', function() {
      if (!available) {
        CarbonToast.show('This colour and size set is out of stock', 2200);
        return;
      }
      var qty = getQty() + 1;
      self.setQuantityForStepper(stepper, qty);
    });

    decBtn.addEventListener('click', function() {
      if (!available) return;
      var qty = Math.max(0, getQty() - 1);
      self.setQuantityForStepper(stepper, qty);
    });
  });
};

BulkOrderGrid.prototype.setQuantityForStepper = function(stepper, qty) {
  if (!stepper) return;
  var color = stepper.dataset.color || '';
  var sizeset = stepper.dataset.sizeset || '';
  var key = color + '::' + sizeset;
  var qtyEl = stepper.querySelector('.carbon-bog__qty');
  var decBtn = stepper.querySelector('.carbon-bog__dec');

  qty = parseInt(qty, 10);
  if (!qty || qty < 0) qty = 0;

  if (qty === 0) delete this.selections[key];
  else this.selections[key] = qty;

  if (qtyEl) {
    qtyEl.textContent = qty;
    qtyEl.dataset.qty = qty;
  }
  if (decBtn) decBtn.style.opacity = qty === 0 ? '0.35' : '1';
  stepper.classList.toggle('carbon-bog__stepper--selected', qty > 0);
  this.el.classList.toggle('carbon-bog--has-selection', this.getTotal() > 0);
};

BulkOrderGrid.prototype.getSelectionParam = function() {
  var self = this;
  var parts = [];

  Object.keys(self.selections).forEach(function(key) {
    var qty = parseInt(self.selections[key], 10);
    if (!qty || qty <= 0) return;

    var keyParts = key.split('::');
    var color = keyParts[0];
    var sizeset = keyParts[1];
    var stepper = null;

    self.el.querySelectorAll('.carbon-bog__stepper').forEach(function(s) {
      if (s.dataset.color === color && s.dataset.sizeset === sizeset) stepper = s;
    });

    if (stepper && stepper.dataset.variantId && stepper.dataset.available !== 'false') {
      parts.push(stepper.dataset.variantId + ':' + qty);
    }
  });

  return parts.join(',');
};

BulkOrderGrid.prototype.getSelectedItems = function() {
  var self = this;
  var items = [];

  Object.keys(self.selections).forEach(function(key) {
    var qty = parseInt(self.selections[key], 10);
    if (!qty || qty <= 0) return;

    var keyParts = key.split('::');
    var color = keyParts[0];
    var sizeset = keyParts[1];
    var stepper = null;

    self.el.querySelectorAll('.carbon-bog__stepper').forEach(function(s) {
      if (s.dataset.color === color && s.dataset.sizeset === sizeset) stepper = s;
    });

    if (!stepper || !stepper.dataset.variantId || stepper.dataset.available === 'false') return;

    var piecesPerVariant = stepper.dataset.piecesPerVariant
      ? parseInt(stepper.dataset.piecesPerVariant, 10)
      : 1;
    if (!piecesPerVariant || piecesPerVariant < 1) piecesPerVariant = 1;

    items.push({
      id: parseInt(stepper.dataset.variantId, 10),
      product_id: parseInt(self.productId, 10),
      product_title: self.productName,
      variant_title: [color, sizeset].filter(Boolean).join(' / '),
      quantity: qty,
      price: stepper.dataset.variantPrice
        ? parseInt(stepper.dataset.variantPrice, 10)
        : Math.round(self.price * 100),
      properties: {
        _pieces_per_variant: String(piecesPerVariant)
      }
    });
  });

  return items;
};

BulkOrderGrid.prototype.applySelectionParam = function(selectionParam) {
  var self = this;
  if (!selectionParam) return;

  selectionParam.split(',').forEach(function(part) {
    var pair = part.split(':');
    if (pair.length !== 2) return;

    var variantId = pair[0];
    var qty = parseInt(pair[1], 10);
    if (!variantId || !qty || qty <= 0) return;

    self.el.querySelectorAll('.carbon-bog__stepper').forEach(function(stepper) {
      if (stepper.dataset.variantId === variantId && stepper.dataset.available !== 'false') {
        self.setQuantityForStepper(stepper, qty);
      }
    });
  });
};

function startBuyNowFlow(bog) {
  if (!bog) return;

  var items = bog.getSelectedItems();
  if (items.length === 0) {
    CarbonToast.show('Tap + to select colour & size set quantities first', 2500);
    return;
  }

  try {
    window.sessionStorage.setItem('carbon_buy_now_items', JSON.stringify(items));
  } catch (err) {
    CarbonToast.show('Could not start Buy Now. Please try again.', 3000);
    return;
  }

  window.location.href = '/pages/generate-pi?source=buy-now';
}

BulkOrderGrid.prototype.getTotal = function() {
  return Object.values(this.selections).reduce(function(a, b) { return a + b; }, 0);
};

BulkOrderGrid.prototype.addToCart = function() {
  var self = this;
  var items = [];

  Object.keys(self.selections).forEach(function(key) {
    var qty = self.selections[key];
    if (qty <= 0) return;
    var parts   = key.split('::');
    var color   = parts[0];
    var sizeset = parts[1];
    var stepper = null;
    self.el.querySelectorAll('.carbon-bog__stepper').forEach(function(s) {
      if (s.dataset.color === color && s.dataset.sizeset === sizeset) stepper = s;
    });
    if (!stepper || stepper.dataset.available === 'false') return;
    var variantId = stepper && stepper.dataset.variantId ? parseInt(stepper.dataset.variantId, 10) : 0;
    var piecesPerVariant = stepper && stepper.dataset.piecesPerVariant
      ? parseInt(stepper.dataset.piecesPerVariant, 10)
      : 1;
    if (!piecesPerVariant || piecesPerVariant < 1) piecesPerVariant = 1;
    if (variantId) {
      items.push({
        id: variantId,
        quantity: qty,
        properties: {
          _pieces_per_variant: String(piecesPerVariant)
        }
      });
    }
  });

  if (items.length === 0) {
    CarbonToast.show('Tap + to select colour & size set quantities first', 2500);
    return;
  }

  var totalPieces = items.reduce(function(s, i) {
    var ppv = i.properties && i.properties._pieces_per_variant ? parseInt(i.properties._pieces_per_variant, 10) : 1;
    return s + (i.quantity * (ppv || 1));
  }, 0);
  var productName = self.productName;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: items })
  })
  .then(function(res) { return res.json(); })
  .then(function(data) {
    if (data.status) {
      CarbonToast.show(data.description || 'Could not add to cart', 3000);
      return;
    }
    self.selections = {};
    self.el.querySelectorAll('.carbon-bog__stepper').forEach(function(stepper) {
      var qtyEl  = stepper.querySelector('.carbon-bog__qty');
      var decBtn = stepper.querySelector('.carbon-bog__dec');
      if (qtyEl)  { qtyEl.textContent = '0'; qtyEl.dataset.qty = '0'; }
      if (decBtn) { decBtn.style.opacity = '0.35'; }
    });
    updateCartBadge();
    CarbonToast.show(totalPieces + ' pcs added — ' + productName);
  })
  .catch(function() {
    CarbonToast.show('Error adding to cart. Please try again.', 3000);
  });
};


// ── FILTER DRAWER ──
function openFilterDrawer(index) {
  var drawer = document.getElementById('filter-drawer-' + index);
  if (!drawer) return;
  drawer.classList.add('open');
  drawer.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function closeFilterDrawer(index) {
  var drawer = document.getElementById('filter-drawer-' + index);
  if (!drawer) return;
  drawer.classList.remove('open');
  drawer.setAttribute('aria-hidden', 'true');
  // Only restore scroll if no other drawers are open
  if (!document.querySelector('.carbon-filter-drawer.open')) {
    document.body.style.overflow = '';
  }
}

function setProductCardImage(productItem, thumb) {
  var mainImage = productItem && productItem.querySelector('[data-card-main-image]');
  if (!mainImage || !thumb || !thumb.dataset.imageSrc) return;

  mainImage.src = thumb.dataset.imageSrc;
  mainImage.alt = thumb.dataset.imageAlt || mainImage.alt;
  productItem.querySelectorAll('[data-card-thumb]').forEach(function(btn) {
    btn.classList.remove('active');
  });
  thumb.classList.add('active');
  productItem.dataset.cardImageIndex = thumb.dataset.cardImageIndex || '0';
}

function initProductCardCarousels() {
  document.querySelectorAll('.carbon-product-item').forEach(function(productItem) {
    var thumbs = Array.from(productItem.querySelectorAll('[data-card-thumb]'));
    if (thumbs.length <= 1 || productItem._cardCarouselTimer) return;

    productItem.dataset.cardImageIndex = productItem.dataset.cardImageIndex || '0';
    productItem._cardCarouselTimer = window.setInterval(function() {
      var current = parseInt(productItem.dataset.cardImageIndex || '0', 10);
      var next = (current + 1) % thumbs.length;
      setProductCardImage(productItem, thumbs[next]);
    }, Math.max(3000, thumbs.length * 900));
  });
}

document.addEventListener('keydown', function(e) {
  if (e.key === 'Escape') {
    document.querySelectorAll('.carbon-filter-drawer.open').forEach(function(drawer) {
      closeFilterDrawer(drawer.id.replace('filter-drawer-', ''));
    });
  }
});

// ── EVENT DELEGATION ──
document.addEventListener('click', function(e) {
  // Buy now — create an isolated PI flow without changing the normal cart
  var buyBtn = e.target.closest('.carbon-btn-buy');
  if (buyBtn) {
    var productScope = buyBtn.closest('.carbon-product-item') || buyBtn.closest('.carbon-page');
    var productId = buyBtn.dataset.buyNow || (productScope && productScope.dataset.productId) || '';
    var bogEl = null;

    if (productId && productScope) {
      bogEl = productScope.querySelector('[data-bog][data-product-id="' + productId + '"]');
    }
    if (!bogEl && productScope) {
      bogEl = productScope.querySelector('[data-bog]');
    }

    if (bogEl && bogEl._bog) {
      e.preventDefault();
      startBuyNowFlow(bogEl._bog);
    }
    return;
  }

  // Add to cart button
  var addBtn = e.target.closest('[data-add-to-cart]');
  if (addBtn) {
    var productId = addBtn.dataset.addToCart;
    var bogEl = document.querySelector('[data-bog][data-product-id="' + productId + '"]');
    if (bogEl && bogEl._bog) {
      bogEl._bog.addToCart();
    } else {
      CarbonToast.show('Added to cart');
    }
    return;
  }

  // Wishlist button
  var wishBtn = e.target.closest('[data-wishlist]');
  if (wishBtn) {
    wishBtn.classList.toggle('active');
    wishBtn.textContent = wishBtn.classList.contains('active') ? '♥' : '♡';
    CarbonToast.show(wishBtn.classList.contains('active') ? 'Added to wishlist' : 'Removed', 1800);
    return;
  }

  // Filter chips — open drawer
  var chip = e.target.closest('.carbon-filter-chip');
  if (chip) {
    var idx = chip.dataset.filterIndex;
    if (idx !== undefined) {
      openFilterDrawer(idx);
    }
    return;
  }

  // Filter drawer close (backdrop or close button)
  var closeEl = e.target.closest('[data-filter-close]');
  if (closeEl) {
    closeFilterDrawer(closeEl.dataset.filterClose);
    return;
  }

  // Product card image thumbnails
  var thumb = e.target.closest('[data-card-thumb]');
  if (thumb) {
    var productItem = thumb.closest('.carbon-product-item');
    if (productItem) {
      setProductCardImage(productItem, thumb);
    }
    return;
  }

  // Product page image thumbnails
  var productThumb = e.target.closest('[data-product-thumb]');
  if (productThumb) {
    var mainProductImage = document.querySelector('[data-product-main-image]');
    if (mainProductImage && productThumb.dataset.imageSrc) {
      mainProductImage.src = productThumb.dataset.imageSrc;
      mainProductImage.alt = productThumb.dataset.imageAlt || mainProductImage.alt;
      document.querySelectorAll('[data-product-thumb]').forEach(function(btn) {
        btn.classList.remove('active');
        btn.style.borderColor = '#E8E8E8';
      });
      productThumb.classList.add('active');
      productThumb.style.borderColor = '#000';
    }
    return;
  }

  // Price range — Apply
  var applyBtn = e.target.closest('[data-price-apply]');
  if (applyBtn) {
    var drawerIdx = applyBtn.dataset.priceApply;
    var drawer = document.getElementById('filter-drawer-' + drawerIdx);
    // Use collection URL as base so applying from homepage navigates to the collection
    var baseHref = applyBtn.dataset.collectionUrl
      ? (window.location.origin + applyBtn.dataset.collectionUrl)
      : window.location.href;
    var url = new URL(baseHref);
    // Carry over any non-price filters already active in the current URL
    new URL(window.location.href).searchParams.forEach(function(val, key) {
      if (key.startsWith('filter.') && key.indexOf('filter.v.price') === -1) {
        url.searchParams.append(key, val);
      }
    });
    drawer.querySelectorAll('.carbon-filter-price__input').forEach(function(input) {
      if (input.value !== '') {
        url.searchParams.set(input.dataset.param, Math.round(parseFloat(input.value) * 100));
      }
    });
    window.location.href = url.toString();
    return;
  }

  // Price range — Clear
  var clearBtn = e.target.closest('[data-price-clear]');
  if (clearBtn) {
    var drawerIdx = clearBtn.dataset.priceClear;
    var drawer = document.getElementById('filter-drawer-' + drawerIdx);
    var url = new URL(window.location.href);
    drawer.querySelectorAll('.carbon-filter-price__input').forEach(function(input) {
      url.searchParams.delete(input.dataset.param);
    });
    window.location.href = url.toString();
    return;
  }

  // Category circles
  var cat = e.target.closest('.carbon-category');
  if (cat) {
    var container = cat.closest('.carbon-categories');
    if (container) {
      container.querySelectorAll('.carbon-category').forEach(function(c) { c.classList.remove('active'); });
      cat.classList.add('active');
    }
    return;
  }
});

// ── INIT ON DOM READY ──
document.addEventListener('DOMContentLoaded', function() {
  var urlParams = new URLSearchParams(window.location.search);
  var selectionParam = urlParams.get('carbon_selection');

  // Init all Bulk Order Grids
  document.querySelectorAll('[data-bog]').forEach(function(el) {
    el._bog = new BulkOrderGrid(el);
    if (selectionParam) el._bog.applySelectionParam(selectionParam);
  });

  if (selectionParam) {
    var selectedGrid = document.querySelector('.carbon-bog--has-selection');
    if (selectedGrid) {
      setTimeout(function() {
        selectedGrid.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, 250);
    }
  }

  initProductCardCarousels();

  // Sync cart badge with real Shopify cart on every page load
  updateCartBadge();

  // Search input — live filter on products already rendered
  var searchInput = document.querySelector('.carbon-search__input');
  if (searchInput) {
    searchInput.addEventListener('input', function() {
      var q = searchInput.value.toLowerCase().trim();
      document.querySelectorAll('.carbon-product-card').forEach(function(card) {
        var name = card.querySelector('.carbon-product-card__name');
        if (!name) return;
        var match = name.textContent.toLowerCase().includes(q);
        var wrap = card.closest('[data-product-id]');
        // Find the card + its bog wrapper (next sibling div)
        var parent = card.parentElement;
        if (parent) {
          // Show/hide both the card and its BOG section
          var nextSib = card.nextElementSibling;
          card.style.display = match || q === '' ? '' : 'none';
          if (nextSib && nextSib.style !== undefined) {
            nextSib.style.display = match || q === '' ? '' : 'none';
          }
        }
      });
    });
  }
});

// ── SORT ──
function carbonSortProducts(sortBy) {
  var url = new URL(window.location.href);
  url.searchParams.set('sort_by', sortBy);
  window.location.href = url.toString();
}

// ── SCROLL SHADOW ──
window.addEventListener('scroll', function() {
  var search = document.querySelector('.carbon-search');
  if (search) {
    search.style.boxShadow = window.scrollY > 4 ? '0 2px 8px rgba(0,0,0,0.08)' : 'none';
  }
}, { passive: true });
